const companies = [
  {
    name: 'VISTA electronic GmbH',
    amount: 6503
  },
  {
    name: 'CATL',
    amount: 6300
  },
  {
    name: 'Qundis GmbH',
    amount: 2490
  },
  {
    name: 'Helios Klinikum Erfurt GmbH',
    amount: 1318
  },
  {
    name: 'DAKO GmbH',
    amount: 900
  },
  {
    name: 'Züblin AG',
    amount: 600
  },
  {
    name: 'CFF GmbH & Co. KG',
    amount: 586
  },
  {
    name: 'BEAK electronic engeneering GmbH & Co. KG',
    amount: 500
  },
  {
    name: 'Verband Thüringer Wohnungs- und Immobilienwirtschaft e.V.',
    amount: 400
  },
  {
    name: 'on-geo GmbH',
    amount: 200
  }
];

const baseWidth = 75;

// Ziel-Container, in dem die Tabellenelemente hinzugefügt werden sollen
const container = document.getElementById("jscStatsTable");

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

for (let i = 0; i < companies.length; i++) {
	container.innerHTML += 
	"<div class='jscRow'>" +
		"<div class='name' id='name" + i +"'>" +
			"<p>" + companies[i].name + "</p>" +
		"</div>" +
		"<div class='chart' id='chart" + i + "'>" +
		"</div>" +
		"<div class='amount' id='amount" + i + "'>" +
			"<p>" + numberWithCommas(companies[i].amount) + "</p>" +
		"</div>" +
	"</div>";
	let rowChart = document.getElementById("chart"+ i );
	let rowChartWidth = baseWidth * (companies[i].amount / companies[0].amount);
	console.log(rowChartWidth);
	rowChart.style.width=  rowChartWidth + "%";
}